module.exports = __webpack_public_path__ + "static/media/fig_14b.f4ded99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_14b.jpg
// module id = 643
// module chunks = 0